import PropTypes from 'prop-types';
import React from 'react';
import { CircularProgress, Button as MuiButton } from '@mui/material';
import { getSx } from './style';

function Button({ children, variant, label, onClick, disabled = false, loading, type, typeButton, style, ...props }) {
  const classes = getSx();

  const getStyles = () => {
    if (type == 'error') return { ...classes.muiButton, ...classes.errorButton, ...(style ? style : {}) };
    else if (type == 'inactive') return { ...classes.muiButton, ...classes.inactive, ...(style ? style : {}) };
    else if (type == 'disabled') return { ...classes.muiButton, ...classes.disabled, ...(style ? style : {}) };
    else return { ...classes.muiButton, ...(style ? style : {}) };
  };

  return (
    <MuiButton
      sx={getStyles()}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      onDoubleClick={(e) => {
        e.stopPropagation()
      }}
      type={typeButton === 'submit' ? typeButton : 'button'}
      {...props}
    >
      {loading ? <CircularProgress size={40} style={{ color: '#FFFFFF' }} /> : <>{children} {label}</>}
    </MuiButton>
  );
}
export default Button;
Button.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
};
